const toDateSafe = (value?: string | null): Date | null => {
    if (!value) return null;

    // dd-MMM-yyyy HH:MM AM/PM
    const dmyShortMonthMatch = /^(\d{1,2})-([A-Za-z]{3})-(\d{4})\s+(\d{1,2}):(\d{2})\s*(AM|PM)$/i.exec(value.trim());
    if (dmyShortMonthMatch) {
        const [, d, mon, y, h, m, mer] = dmyShortMonthMatch;
        const monthNames = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
        const monthIndex = monthNames.indexOf(mon.toLowerCase());
        if (monthIndex >= 0) {
            let hour = Number(h) % 12;
            if (mer.toUpperCase() === "PM") hour += 12;
            const date = new Date(Date.UTC(Number(y), monthIndex, Number(d), hour, Number(m)));
            return Number.isNaN(date.getTime()) ? null : date;
        }
    }

    // yyyy-mm-dd or yyyy/mm/dd
    const isoMatch = /^(\d{4})[-/](\d{2})[-/](\d{2})/.exec(value);
    if (isoMatch) {
        const [, year, month, day] = isoMatch;
        const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
        return Number.isNaN(date.getTime()) ? null : date;
    }

    // dd-mm-yyyy or dd/mm/yyyy
    const dmyMatch = /^(\d{2})[-/](\d{2})[-/](\d{4})/.exec(value);
    if (dmyMatch) {
        const [, day, month, year] = dmyMatch;
        const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatDisplayDate = (value?: string | null): string => {
    const parsed = toDateSafe(value);
    if (!parsed) {
        return value || "N/A";
    }

    const day = String(parsed.getUTCDate()).padStart(2, "0");
    const month = String(parsed.getUTCMonth() + 1).padStart(2, "0");
    const year = parsed.getUTCFullYear();

    return `${day}-${month}-${year}`;
};

export const formatDisplayDateLong = (value?: string | null): string => {
    const parsed = toDateSafe(value);
    if (!parsed) {
        return value || "N/A";
    }

    const day = String(parsed.getUTCDate()).padStart(2, "0");
    const monthIndex = parsed.getUTCMonth();
    const year = parsed.getUTCFullYear();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const monthLabel = months[monthIndex] ?? "";

    return `${day} ${monthLabel}, ${year}`;
};

export const formatDisplayTime = (value?: string | null): string => {
    const parsed = toDateSafe(value);
    if (!parsed) {
        return value || "TBD";
    }

    let hours = parsed.getUTCHours();
    const minutes = String(parsed.getUTCMinutes()).padStart(2, "0");
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    return `${String(hours).padStart(2, "0")}:${minutes} ${meridiem}`;
};
